/**
 * Чи пора показувати привітання (UX-38) — рішення ДО `import()` чанка `Welcome`: людина, якій
 * привітання вже показували, чанка не вантажить зовсім (≈1,2 КБ gzip на кожному старті). Позначка
 * `welcomed` живе в `prefs/sync.ts` (перший екран). Поки сервер не відповів (`welcomed === null`)
 * — «ні».
 */
import { useEffect, useState } from 'react';
import { getServerPrefs, subscribeServerPrefs } from '../prefs/sync.ts';

export function useWelcomeDue(enabled: boolean): boolean {
  const [due, setDue] = useState(false);
  useEffect(() => {
    if (!enabled) {
      setDue(false);
      return;
    }
    const read = () => setDue(getServerPrefs().welcomed === false);
    const off = subscribeServerPrefs(read);
    read();
    return () => {
      off();
    };
  }, [enabled]);
  return due;
}
